import { ApiKey } from "../apiKeys";
import { authAxios } from "../config";
import { ProfileType } from "../../types/userTypes";
import { checkTokenValidation } from "../auth/tokenReq";
import { companyType } from "../../types/comapnyTypes";

export const getCompanyList = async () => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": companyReq->getCompanytList " + t
    );
  try {
    await checkTokenValidation();

    const res = await authAxios.get(`${ApiKey.getCompanyListKey}`);
    // logfun(res.data, "res");
    const resData = res.data?.company;
    const _msg = resData.message || "";
    const _data = resData?.map((item: companyType) => ({
      companyID: item?.companyID || "",
      CompanyName: item?.CompanyName || "",
      comp1LinerHeadline: item?.comp1LinerHeadline || "",
      comp1LinerDesc: item?.comp1LinerDesc || "",
      GSTNo: item?.GSTNo || "",
      companyAddressLine1: item?.companyAddressLine1 || "",
      companyAddressLine2: item?.companyAddressLine2 || "",
      companyCity: item?.companyCity || "",
      companyState: item?.companyState || "",
      companyPinCode: item?.companyPinCode || "",
      companyCountry: item?.companyCountry || "",
      companyWebLogoURL: item?.companyWebLogoURL || "",
      companyLogoURL: item?.companyLogoURL || "",
      subscriptionActiveDate: item?.subscriptionActiveDate || "",
      subscriptionValidUpto: item?.subscriptionValidUpto || "",
      lastAmtPaid: item?.lastAmtPaid || "",
      lastPaymentDate: item?.lastPaymentDate || "",
      Status: item?.Status || "",
      userID: item?.userID || "",
      subscriptionID: item?.subscriptionID || "",
    }));
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const getCompanyDetailsByID = async (params: { companyID: number }) => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": companyReq->getCompanytList " + t
    );
  try {
    await checkTokenValidation();

    const res = await authAxios.get(
      `${ApiKey.getCompanyDetailsByIdKey}/${params?.companyID}/details`
    );
    // logfun(res.data, "res");
    const resData = res.data?.company;
    const _msg = res?.data?.message || "";
    const _data = {
      companyID: resData?.companyID || "",
      CompanyName: resData?.CompanyName || "",
      comp1LinerHeadline: resData?.comp1LinerHeadline || "",
      comp1LinerDesc: resData?.comp1LinerDesc || "",
      GSTNo: resData?.GSTNo || "",
      companyAddressLine1: resData?.companyAddressLine1 || "",
      companyAddressLine2: resData?.companyAddressLine2 || "",
      companyCity: resData?.companyCity || "",
      companyState: resData?.companyState || "",
      companyPinCode: resData?.companyPinCode || "",
      companyCountry: resData?.companyCountry || "",
      companyWebLogoURL: resData?.companyWebLogoURL || "",
      companyLogoURL: resData?.companyLogoURL || "",
      subscriptionActiveDate: resData?.subscriptionActiveDate || "",
      subscriptionValidUpto: resData?.subscriptionValidUpto || "",
      lastAmtPaid: resData?.lastAmtPaid || "",
      lastPaymentDate: resData?.lastPaymentDate || "",
      Status: resData?.Status || "",
      userID: resData?.userID || "",
      createdAt: resData?.createdAt || "",
      subscriptionID: resData?.subscriptionID || "",
      subscription: resData?.subscription?.map((item: any) => ({
        subscriptionName: item?.subscriptionName || "",
        subscriptionFees: item?.subscriptionFees || "",
        subscriptionID: item?.subscriptionID || "0",
      })),
      EAdmin: resData?.EAdmin?.map((item: any) => ({
        firstName: item?.employee?.firstName || "",
        lastName: item?.employee?.lastName || "",
        email: item?.user?.email || "",
        mobileNumber: item?.user?.mobileNumber || "",
        designation: item?.employee?.designation || "",
      })),
      CEPPartnerDetails: resData?.CEPPartnerDetails?.map((item: any) => ({
        firstName: item[0].firstName || "",
        lastName: item[0].lastName || "",
      })),
    };
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

export const getCompanyStatsReq = async (params: { companyID: number }) => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": companyReq->getCompanyStatsReq " + t
    );
  try {
    await checkTokenValidation();

    const res = await authAxios.get(
      `${ApiKey.getCompanyStatsByIdKey}/${params?.companyID}/stats`
    );
    // logfun(res.data, "res");
    const resData = res.data?.company;
    const _msg = res?.data?.message || "";
    const _data = {
      candidateCount: resData?.candidateCount || "0",
      recruiterCount: resData?.recruiterCount || "0",
      joinedCandidatesCount: resData?.joinedCandidatesCount || "0",
      dropoutCandidatesCount: resData?.dropoutCandidatesCount || "0",
      cardSetsCount: resData?.cardSetsCount || "0",
      joiners: resData?.joiners || "0",
      companyStats: resData?.companyStats?.map((item: any) => ({
        Month: item?.Month || "",
        Issued: item?.Issued || "0",
        Accepted: item?.Accepted || "0",
        Declined: item?.Declined || "0",
        Total_Engaged: item?.Total_Engaged || "0",
        Joined: item?.Joined || "0",
        Dropouts: item?.Dropouts || "0",
      }))
    };
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};
